<template lang="pug">
    .thumbnail-component
        .thumbnail-component__failed(v-if="!model")
            div
                .thumbnail-component__failed-content
                    i.editor-icon.editor-icon__template-thumbnail-missing
                    span Image cannot be loaded

        .thumbnail-component__failed(v-else-if="thumbnailFailed")
            div
                .thumbnail-component__failed-content
                    i.editor-icon.editor-icon__template-thumbnail-missing
                    span Image cannot be generated

        .thumbnail-component__loading(v-else-if="thumbnailRequested || !thumbnailUrl")
            div
                .thumbnail-component__loader
                    i.editor-icon.editor-icon__loading-circle
                    span Preparing...

        img(v-else-if="thumbnailUrl" :src="thumbnailUrl" draggable="false")
</template>

<script>
import _ from 'lodash'
import thumbnailMixin from '../mixins/store/thumbnail-generator-mixin'

export default {
    name: 'thumbnail-component',

    mixins: [
        thumbnailMixin
    ],

    props: {
        value: {
            type: Object | Array | String,
        },
        disableAutoRefresh: {
            type: Boolean,
        },
    },

    computed: {
        model() {
            if (!this.value) {
                return this.value
            }
            if (typeof(this.value) == 'object') {
                return this.value
            }
            if (typeof(this.value) == 'string') {
                return JSON.parse(this.value)
            }
            return this.value
        },

        modelIsThumbnailSet() {
            return !Array.isArray(this.model)
        },

        thumbnailSet: {
            get() {
                return this.modelIsThumbnailSet ? this.model : null
            },
            set(val) {
                if (this.modelIsThumbnailSet) {
                    this.$emit('input', val)
                }
            },
        },

        thumbnailSetId() {
            return this.thumbnailSet?.id
        },
        thumbnails() {
            return this.modelIsThumbnailSet ? this.thumbnailSets[this.thumbnailSetId].thumbnails : this.model
        },
        // config() {
        //     return this.thumbnailSet.config
        // },

        // TODO: in future make the component to work with multiple thumbnails with different sizes
        thumbnail() {
            return this.thumbnails[0]
        },
        thumbnailUrl() {
            return this.thumbnail?.url
        },
        thumbnailInvalidated() {
            return this.thumbnail?.invalidated
        },
        thumbnailRequested() {
            return this.thumbnail?.requested
        },
        thumbnailFailed() {
            return this.thumbnail?.failed
        },
    },

    watch: {
        thumbnailSet() {
            this.initThumbnailSet()
        },
    },

    methods: {
        initThumbnailSet() {
            if (!this.model || !this.modelIsThumbnailSet) {
                return
            }

            const thumbnailSet = this.thumbnailSet

            if (!thumbnailSet.thumbnails.length) {
                thumbnailSet.thumbnails.push({})
            }

            this.updateThumbnailSet(thumbnailSet)

            if (!this.disableAutoRefresh || !this.thumbnailUrl) {
                this.invokeRequest()
            }
        },

        invokeRequest() {
            if ((!this.thumbnailUrl || this.thumbnailInvalidated || this.thumbnailRequested) && !this.thumbnailFailed) {
                this.addRequestThumbnailSetId(this.thumbnailSetId)
            }
        },
    },

    created() {
        this.initThumbnailSet()
    },
}
</script>

<style lang="scss">
    @import '../../scss/components/thumbnail-component.scss';
</style>
